import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { FileService } from "src/app/core/services/file.service";

/**
 * EditPhoto modal
 * 
 * 
 */
@Component({
  selector: "app-edit-photo",
  templateUrl: "./edit-photo.component.html",
  styleUrls: ["./edit-photo.component.scss"],
})
export class EditPhotoComponent implements OnInit {
  // Initial image data in base64 format
  @Input() set image(data: string) {
    this.imageData = data;
  }

  // Save event emitter
  @Output() save = new EventEmitter<string>();

  // Cancel event emitter
  @Output() cancel = new EventEmitter();

  imageData = "";
  croppedImage = "";

  constructor(private file: FileService) {}

  ngOnInit(): void {}

  /**
   * Select photo event handler. Only select png or jpg files.
   */
  selectPhoto() {
    this.file
      .selectFile(false, ["png", "jpg"])
      .pipe(
        switchMap((files) =>
          files[0] ? this.file.readFileContent(files[0], "dataUrl") : of("")
        )
      )
      .subscribe((imageData) => {
        this.imageData = imageData;
      });
  }

  /**
   * Clear canvas
   */
  clearPhoto() {
    this.imageData = "";
    this.croppedImage = "";
  }

  /**
   * Set cropped image.
   * @param croppedImage Cropped image data in base64 format.
   */
  imageCropped(croppedImage: string) {
    this.croppedImage = croppedImage;
  }

  /**
   * Save photo event handler.
   */
  savePhoto() {
    this.save.emit(this.croppedImage);
  }

  /**
   * Cancel event emitter.
   */
  closeModal() {
    this.cancel.emit();
  }
}
